// extracted by mini-css-extract-plugin
export default {"grid":"Mission_grid__m2BXC","statement":"Mission_statement__c95PO","values":"Mission_values__QvC7e","value":"Mission_value__2JYmf"};